"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Money = function Money(_ref) {
  var className = _ref.className;
  return _react["default"].createElement("svg", {
    className: className,
    width: "52",
    height: "52",
    viewBox: "0 -46 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("path", {
    d: "m90 340c-5.519531 0-10 4.480469-10 10s4.480469 10 10 10 10-4.480469 10-10-4.480469-10-10-10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m257 179.289062c-4.273438 0-8.886719-2.6875-12.984375-7.5625-3.554687-4.230468-9.863281-4.777343-14.089844-1.21875-4.230469 3.550782-4.773437 9.859376-1.21875 14.085938 5.34375 6.359375 11.632813 10.792969 18.292969 13.023438v11.671874c0 5.523438 4.476562 10 10 10s10-4.476562 10-10v-11.71875c11.640625-4.128906 20-15.242187 20-28.28125 0-16.542968-13.457031-30-30-30-5.515625 0-10-4.484374-10-10 0-5.511718 4.484375-10 10-10 3.542969 0 7.28125 1.808594 10.816406 5.226563 3.96875 3.84375 10.296875 3.738281 14.140625-.230469 3.839844-3.96875 3.734375-10.300781-.234375-14.140625-5.074218-4.910156-10.152344-7.691406-14.722656-9.207031v-11.648438c0-5.523437-4.476562-10-10-10s-10 4.476563-10 10v11.722657c-11.640625 4.125-20 15.242187-20 28.277343 0 16.542969 13.457031 30 30 30 5.515625 0 10 4.488282 10 10 0 5.515626-4.484375 10-10 10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m502 0h-492c-5.523438 0-10 4.476562-10 10v400c0 5.523438 4.476562 10 10 10h492c5.523438 0 10-4.476562 10-10 0-7.269531 0-383.199219 0-400 0-5.523438-4.476562-10-10-10zm-482 20h472v260h-472zm0 380v-40h30c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-30v-40h472v40h-362c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h362v40zm0 0"
  }), _react["default"].createElement("path", {
    d: "m462 80c-16.542969 0-30-13.457031-30-30 0-5.523438-4.476562-10-10-10h-332c-5.523438 0-10 4.476562-10 10 0 16.542969-13.457031 30-30 30-5.523438 0-10 4.476562-10 10v120c0 5.523438 4.476562 10 10 10 16.542969 0 30 13.457031 30 30 0 5.523438 4.476562 10 10 10h332c5.523438 0 10-4.476562 10-10 0-16.542969 13.457031-30 30-30 5.523438 0 10-4.476562 10-10v-120c0-5.523438-4.476562-10-10-10zm-363.003906 160c-3.988282-19.5625-19.433594-35.007812-38.996094-38.996094v-102.007812c19.5625-3.988282 35.007812-19.445313 38.996094-39.007813h93.832031c-28.300781 19.925781-46.828125 52.847657-46.828125 90.011719s18.527344 70.074219 46.828125 90zm157.003906-180c49.625 0 90 40.375 90 90s-40.375 90-90 90-90-40.375-90-90 40.375-90 90-90zm196 141.003906c-19.5625 3.988282-35.007812 19.433594-38.996094 38.996094h-93.832031c28.300781-19.925781 46.828125-52.835938 46.828125-90s-18.527344-70.074219-46.828125-90h93.832031c3.988282 19.5625 19.433594 35.007812 38.996094 38.996094zm0 0"
  }));
};

Money.displayName = 'Money';
Money.propTypes = {
  className: _propTypes["default"].string
};
Money.defaultProps = {
  className: ''
};
var _default = Money;
exports["default"] = _default;